import { getRefName as e } from "./get-ref-name.js";
import { getResolvedRef as t } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { resolve as n } from "@scalar/workspace-store/resolve";
//#region src/schema/helpers/get-type-signature-tokens.ts
var r = 3, i = [
	"x-enumDescriptions",
	"x-enum-descriptions",
	"x-enum-varnames",
	"x-enumNames"
], a = (e) => typeof e == "object" && e ? JSON.stringify(e) : typeof e == "string" ? `"${e}"` : String(e), o = (e) => ({
	kind: "word",
	text: e
}), s = (e) => ({
	kind: "ident",
	text: e
}), c = (e) => ({
	kind: "literal",
	text: e
}), l = () => ({
	kind: "punctuation",
	text: "|"
}), u = (e, t) => e.flatMap((e, n) => n === 0 ? e : [...t(), ...e]), d = (a, o = {}, s = !1) => {
	if (!a || typeof a != "object" || "$ref" in a && typeof a.$ref == "string" && !o.hideModelNames && e(a.$ref)) return !1;
	let c = o.hideModelNames ? n.schema(a) : t(a);
	if (!c || typeof c != "object" || c.const !== void 0) return !1;
	if (!i.some((e) => c[e]) && Array.isArray(c.enum) && c.enum.length > 0 && c.enum.length <= r) return !0;
	if (!s && !("type" in c)) return !1;
	let l = "type" in c ? c.type : void 0, u = l === "array" || Array.isArray(l) && l.includes("array"), f = "items" in c ? c.items : void 0;
	return u && f && typeof f == "object" ? d(f, o, !0) : !1;
}, f = (d, f = {}, p = 0) => {
	if (!d || typeof d != "object") return [];
	if ("$ref" in d && typeof d.$ref == "string") {
		let t = f.hideModelNames ? null : e(d.$ref);
		if (t) return [s(t)];
	}
	let m = f.hideModelNames ? n.schema(d) : t(d);
	return !m || typeof m != "object" ? [] : m.const === void 0 ? Array.isArray(m.enum) && m.enum.length > 0 && m.enum.length <= r && !i.some((e) => m[e]) ? u(m.enum.map((e) => [c(a(e))]), () => [o("or")]) : "type" in m && Array.isArray(m.type) ? u(m.type.map((e) => e === "array" ? h(m, f, p) : [s(String(e))]), () => [l()]) : "type" in m && m.type === "array" ? h(m, f, p) : "type" in m && m.type && m.contentEncoding ? [
		s(String(m.type)),
		o("•"),
		s(m.contentEncoding)
	] : "type" in m && m.type ? [s(String(m.type))] : [] : [c(a(m.const))];
}, p = (e, t = {}) => {
	let n = f(e, { hideModelNames: t.hideModelNames }), r = t.modelName;
	if (t.hideModelNames || !r) return n;
	let i = (e) => !!e && typeof e == "object" && "$ref" in e;
	if (n.length === 0 || n.length === 1 && n[0]?.text === "object" || i(e) && n.length === 1 && n[0]?.kind === "ident" && n[0]?.text !== r) return [s(r)];
	let a = e && typeof e == "object" && "items" in e ? e.items : void 0, o = n[0], c = n[1];
	if (i(a) && n.length === 2 && o?.kind === "word" && c?.kind === "ident" && r.endsWith("[]")) {
		let e = r.slice(0, -2);
		if (e && e !== c.text) return [o, s(e)];
	}
	return n;
}, m = 8, h = (e, t, n) => {
	let r = "items" in e ? e.items : void 0;
	if (!r || n >= m) return [s("array")];
	let i = f(r, t, n + 1);
	return i.length === 0 ? [s("array")] : [o("array of"), ...i];
};
//#endregion
export { p as getDisplayTypeSignatureTokens, f as getTypeSignatureTokens, d as typeSignatureInlinesEnum };

//# sourceMappingURL=get-type-signature-tokens.js.map